module.exports = __webpack_public_path__ + "static/media/logo-cenfarte-no-isotype-white.b5c72932.svg";